enum MyAccountStatic {
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description obtener el parent del usuario autenticado
   */
  MyAccountParent = "/v2/admin/my-account/parent"
}

const MyAccountDynamic = {
  // dinámicos no aplican por ahora
};

export const MyAccountEndpoints = {
  ...MyAccountDynamic,
  ...MyAccountStatic
};

export type MyAccountEndpoints = typeof MyAccountEndpoints;
